import { Trans, useTranslation } from "react-i18next";
import ceoPng from "../assets/ceo1.jpg";
import "../styles/AboutSection.css";

export default function AboutSection() {
  const { t } = useTranslation("about");
  const body = t("body", { returnObjects: true });

  return (
    <section className="about-section">
      <div className="about-container">

        <div className="about-text">
          <span className="about-eyebrow">{t("eyebrow")}</span>
          <h2 className="about-title">{t("title")}</h2>
          <div className="about-body">
            {body.map((_, i) => (
              <p key={i}>
                <Trans i18nKey={`body.${i}`} ns="about" components={{ strong: <strong /> }} />
              </p>
            ))}
          </div>
        </div>

        <div className="about-visual">
          <div className="about-photo-wrap">
            <img
              src={ceoPng}
              alt="CEO, Connect Moon"
              className="about-photo"
              loading="lazy"
            />
            <div className="about-photo-card">
              <strong>Lauanda Martins</strong>
              <span>{t("ceoRole")}</span>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
